import { render, staticRenderFns } from "./set-goods.vue?vue&type=template&id=5fde6492&scoped=true"
import script from "./set-goods.vue?vue&type=script&lang=js"
export * from "./set-goods.vue?vue&type=script&lang=js"
import style0 from "./set-goods.vue?vue&type=style&index=0&id=5fde6492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde6492",
  null
  
)

export default component.exports